import { z } from 'zod';
import { Services } from './services/Services.js';
import './configurations/AiBdcSettings.js';
import { assemblyServiceConfigSchema } from './configurations/AssemblyServiceConfig.js';
import { bdcServiceConfigSchema } from './configurations/BdcServiceConfig.js';
import { coverageFulfillmentServiceConfigSchema } from './configurations/CoverageFulfillmentServiceConfig.js';
import { coveragePlatformServiceConfigSchema } from './configurations/CoveragePlatformServiceConfig.js';
import { coverageTaxServiceConfigSchema } from './configurations/CoverageTaxServiceConfig.js';
import { coverageVendorServiceConfigSchema } from './configurations/CoverageVendorServiceConfig.js';
import { deliveryServiceConfigSchema } from './configurations/DeliveryServiceConfig.js';
import { domainsServiceConfigSchema } from './configurations/DomainsServiceConfig.js';
import { externalFeesServiceConfigSchema } from './configurations/ExternalFeesServiceConfig.js';
import { externalTaxServiceConfigSchema } from './configurations/ExternalTaxServiceConfig.js';
import { financingBrokeragePlatformServiceConfigSchema } from './configurations/FinancingBrokeragePlatformServiceConfig.js';
import { financingBrokerageServiceConfigSchema } from './configurations/FinancingBrokerageServiceConfig.js';
import { financingBrokerageSubventionServiceConfigSchema } from './configurations/FinancingBrokerageSubventionServiceConfig.js';
import { financingServiceConfigSchema } from './configurations/FinancingServiceConfig.js';
import { freightServiceConfigSchema } from './configurations/FreightServiceConfig.js';
import { inspectionServiceConfigSchema } from './configurations/InspectionServiceConfig.js';
import { internalFeesServiceConfigSchema } from './configurations/InternalFeesServiceConfig.js';
import { inventoryServiceConfigSchema } from './configurations/InventoryServiceConfig.js';
import { licensureServiceConfigSchema } from './configurations/LicensureServiceConfig.js';
import { pickupServiceConfigSchema } from './configurations/PickupServiceConfig.js';
import { platformServiceConfigSchema } from './configurations/PlatformServiceConfig.js';
import { processingFeesServiceConfigSchema } from './configurations/ProcessingFeesServiceConfig.js';
import { programOwnerServiceConfigSchema } from './configurations/ProgramOwnerServiceConfig.js';
import { RegistrationServiceConfigSchema } from './configurations/RegistrationServiceConfig.js';
import { saleServiceConfigSchema } from './configurations/SaleServiceConfig.js';
import { serviceConfigSchema } from './configurations/SharedServiceConfig.js';
import { TariffServiceConfigSchema } from './configurations/TariffServiceConfig.js';
import { tempTagServiceConfigSchema } from './configurations/TempTagServiceConfig.js';
import { TitlingServiceConfigSchema } from './configurations/TitlingServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const servicesProviderConfigSchema = z.object({
    [Services.PROGRAM_OWNER]: programOwnerServiceConfigSchema.optional(),
    [Services.DOMAINS]: domainsServiceConfigSchema.optional(),
    [Services.SALE]: saleServiceConfigSchema.optional(),
    [Services.DELIVERY]: deliveryServiceConfigSchema.optional(),
    [Services.PICKUP]: pickupServiceConfigSchema.optional(),
    [Services.ASSEMBLY]: assemblyServiceConfigSchema.optional(),
    [Services.INSPECTION]: inspectionServiceConfigSchema.optional(),
    [Services.TITLING]: TitlingServiceConfigSchema.optional(),
    [Services.REGISTRATION]: RegistrationServiceConfigSchema.optional(),
    [Services.FINANCING]: financingServiceConfigSchema.optional(),
    [Services.FINANCING_BROKERAGE]: financingBrokerageServiceConfigSchema.optional(),
    [Services.FINANCING_BROKERAGE_PLATFORM]: financingBrokeragePlatformServiceConfigSchema.optional(),
    [Services.LICENSURE]: licensureServiceConfigSchema.optional(),
    [Services.TARIFF]: TariffServiceConfigSchema.optional(),
    [Services.INVENTORY]: inventoryServiceConfigSchema.optional(),
    [Services.PLATFORM]: platformServiceConfigSchema.optional(),
    [Services.FREIGHT]: freightServiceConfigSchema.optional(),
    [Services.PROCESSING_FEES]: processingFeesServiceConfigSchema.optional(),
    [Services.COVERAGE_FULFILLMENT]: coverageFulfillmentServiceConfigSchema.optional(),
    [Services.COVERAGE_VENDOR]: coverageVendorServiceConfigSchema.optional(),
    [Services.COVERAGE_PLATFORM]: coveragePlatformServiceConfigSchema.optional(),
    [Services.COVERAGE_TAX]: coverageTaxServiceConfigSchema.optional(),
    [Services.EXTERNAL_TAX]: externalTaxServiceConfigSchema.optional(),
    [Services.EXTERNAL_FEES]: externalFeesServiceConfigSchema.optional(),
    [Services.INTERNAL_FEES]: internalFeesServiceConfigSchema.optional(),
    [Services.ORIGINATOR]: serviceConfigSchema.optional(),
    [Services.TEMP_TAG]: tempTagServiceConfigSchema.optional(),
    [Services.FINANCING_BROKERAGE_SUBVENTION]: financingBrokerageSubventionServiceConfigSchema.optional(),
    [Services.BDC]: bdcServiceConfigSchema.optional(),
});

export { servicesProviderConfigSchema };
//# sourceMappingURL=ServicesProviderConfig.js.map
